import React from "react";
import { useTranslation } from "react-i18next";
import WrapperPage from "../../components/WrapperPage";
import BaseButton from "../../components/BaseButton";
import PersonalAccount from "../../store/PersonalAccount";
import { useLocation, useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import Game from "../../store/Game";
import DescriptionTitleArrow from "../../assets/images/description_title_arrow.png";
import BgBf14 from "../../assets/images/bg_bf_14.png";
import BgBf15 from "../../assets/images/bg_bf_15.png";
import BgBf16 from "../../assets/images/bg_bf_16.png";
import BgBf17 from "../../assets/images/bg_bf_17.png";
import ROUTES from "../../utils/routes.js";
import useAuth from "../../hooks/useAuth";
import getDomainPrice from "../../utils/getDomainPrice";
import useModalActions from "../../hooks/useModalActions";
import { MODAL_TYPES } from "../../utils/emitter";
import AnketaDescriptionBody from "../../components/AnketaDescriptionBody";
import BuyMoneyPointsRow from "../../components/BuyMoneyPointsRow";
import "./style.scss";

export default observer(function InsightNewFormDescriptionPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { game } = Game;
  const { token } = useAuth();
  const { openModal } = useModalActions();
  const isDemo = (game && game.type === "DEMO") || !game;
  // 21.09: раньше открытие описания засчитывалось как «инструкция прочитана» —
  // это было верно, пока инструкция была вшита в эту же страницу. Блок отсюда убран,
  // поэтому флаг больше НЕ ставим: иначе создание первой анкеты (InGamePage) молча
  // пропускало бы /insight-instruction, и юзер не увидел бы инструкцию никогда.

  // есть ли у юзера своя чистая анкета: куплена (available) или уже создана (created)
  const ent = PersonalAccount.user?.entitlements;
  const hasOwnBlankForms =
    (ent?.blankFormsAvailable ?? 0) > 0 || (ent?.blankFormsCreated ?? 0) > 0;

  function onClickBuy() {
    if (!token) {
      // item 12: гость с намерением купить не должен «теряться» в ЛК после
      // регистрации. Флаг buttonType:"buyGame" → RegisterPage после регистрации
      // ведёт на PAYMENT_PAGE (оплату игры), а не в личный кабинет.
      // намерение «купить» — только для некупленной игры. Гость в уже оплаченной
      // игре (присоединился к партнёру) видит «Начать», и слать его на оплату нельзя
      navigate(
        ROUTES.REGISTER_PAGE,
        isDemo ? { state: { buttonType: "buyGame" } } : undefined
      );
      return;
    }
    // ТЗ п.7.2: анкета откровений — попап покупки игры с 2 кнопками (деньги/баллы).
    // item 4: variant:"anketa" → попап показывает Анкета-текст, а не «весь тест».
    isDemo
      ? openModal(MODAL_TYPES.BUY_PRODUCT, {
          productType: "GAME",
          variant: "anketa",
          gameId: game?.id,
          from: location.pathname,
        })
      : navigate(ROUTES.INSIGHT_QUESTIONNAIRE_PAGE);
  }
  return (
    <>
      <div className="insight-form-new-description-page centering-page">
        <img
          className="insight-form-new-description-page__bgbf14"
          src={BgBf14}
          alt=""
        />
        <img
          className="insight-form-new-description-page__bgbf15"
          src={BgBf15}
          alt=""
        />
        <img
          className="insight-form-new-description-page__bgbf14_rotated"
          src={BgBf14}
          alt=""
        />
        <img
          className="insight-form-new-description-page__bgbf17"
          src={BgBf17}
          alt=""
        />
        <WrapperPage
          headerTitle={t("insight_form_new_description_page.title")}
          backBtn
          loginBtn={!token}
          burgerMenu={isDemo && !token ? false : true}
        >
          <AnketaDescriptionBody withFinal={!!token} />
        </WrapperPage>
      </div>
      <div className="insight_form_new_instruction_page centering-page">
        <img
          className="insight_form_new_instruction_page__bgbf16"
          src={BgBf16}
          alt=""
        />
        <img
          className="insight_form_new_instruction_page__bgbf14"
          src={BgBf14}
          alt=""
        />
        {/* 21.09 (решение клиента): блок «Инструкция» со страницы описания убран —
            описание теперь показывается и страницей, и попапом там, где карточек ещё
            нет, а инструкция живёт отдельной страницей /insight-instruction.
            Заголовка у этой секции больше нет: она продолжает описание, а не
            начинает новый раздел. Декоративные бабочки и финальный блок с кнопками
            покупки оставлены на месте. */}
        {/* 28.09 (баг клиента): гость, пришедший из теста по иконке анкеты, должен
            увидеть описание + ИНСТРУКЦИЮ + покупку — это воронка «погрузить в контекст
            и продать». 21.09 инструкцию отсюда убрали для всех; возвращаем её только
            гостю. Залогиненные попадают сюда редко (бургер без игры) и видят страницу
            как решили 21.09 — без инструкции. */}
        <WrapperPage
          headerTitle={!token ? t("insight_form_instruction_page.title") : undefined}
        >
          {!token && (
            <>
          <div className="insight_form_new_instruction_page__subtitles">
            <div className="insight_form_new_instruction_page__subtitle-2">
              {t("insight_form_instruction_page.subtitle_2")}
            </div>
          </div>

          <div className="insight_form_new_instruction_page__blocks">
            <div className="insight_form_new_instruction_page__top-blocks">
              <div className="insight_form_new_instruction_page__left-blocks">
                <div className="insight_form_new_instruction_page__block">
                  <div className="insight_form_new_instruction_page__block-number">
                    1
                  </div>
                  <div className="insight_form_new_instruction_page__block-desc">
                    {t("insight_form_instruction_page.block_one")}
                  </div>
                </div>
                <div className="insight_form_new_instruction_page__block">
                  <div className="insight_form_new_instruction_page__block-number">
                    2
                  </div>
                  <div className="insight_form_new_instruction_page__block-desc">
                    {t("insight_form_instruction_page.block_two")}
                  </div>
                </div>
                <div className="insight_form_new_instruction_page__block">
                  <div className="insight_form_new_instruction_page__block-number">
                    3
                  </div>
                  <div className="insight_form_new_instruction_page__block-desc">
                    {t("insight_form_instruction_page.block_three")}
                  </div>
                </div>
              </div>
              <div className="insight_form_new_instruction_page__right-blocks">
                <div className="insight_form_new_instruction_page__right-blocks-warn">
                  {t("insight_form_instruction_page.warning")}
                </div>
                <div className="insight_form_new_instruction_page__right-blocks-desc">
                  {t("insight_form_instruction_page.block_warning.desc1")}
                </div>
                <div className="insight_form_new_instruction_page__right-blocks-desc">
                  {t("insight_form_instruction_page.block_warning.desc2")}
                </div>
                <div className="insight_form_new_instruction_page__right-blocks-desc">
                  {t("insight_form_instruction_page.block_warning.desc3")}
                </div>
              </div>
            </div>
            <div className="insight_form_new_instruction_page__bottom-block">
              <div className="insight_form_new_instruction_page__block-number">
                4
              </div>
              <div className="insight_form_new_instruction_page__block-desc">
                {t("insight_form_instruction_page.block_four")}
              </div>
            </div>
          </div>

          <div className="insight_form_new_instruction_page__final-text insight_form_new_instruction_page__final-text-1">
            <div>
              <img src={DescriptionTitleArrow} alt="" />{" "}
              {t("insight_form_instruction_page.finalText1")}
            </div>
          </div>
          <div className="insight_form_new_instruction_page__final-text insight_form_new_instruction_page__final-text-1">
            {t("insight_form_instruction_page.finalText3")}
          </div>
          <div className="insight_form_new_instruction_page__final-text insight_form_new_instruction_page__final-text-1">
            {t("insight_form_instruction_page.finalText4")}
          </div>
          <div className="insight_form_new_instruction_page__final-text insight_form_new_instruction_page__final-text-1">
            {t("insight_form_instruction_page.finalText5")}
          </div>
              <div className="insight-form-new-description-page__final-text">
                <div>{t("insight_form_description_page.finalText")}</div>
              </div>
            </>
          )}
          {/* item 4: у кого чистая анкета уже куплена или создана — ведём СНАЧАЛА к его
              анкетам (там же лежит черновик), а предложение купить полную игру остаётся
              ниже. Раньше на DEMO-игре единственной кнопкой было «купить игру за 49$»,
              и владелец купленной чистой анкеты не имел отсюда пути к своему черновику. */}
          {hasOwnBlankForms && (
            <div className="insight-form-new-description-page__buy-button">
              <BaseButton
                onClick={() => navigate(ROUTES.INSIGHT_QUESTIONNAIRE_PAGE)}
              >
                {t("insight_form_page.my_forms")}
              </BaseButton>
            </div>
          )}
          {/* 21.09: вместо одной кнопки «Купить за 49$», открывавшей попап с теми же
              кнопками, покупка теперь прямо здесь — деньги/баллы, как в попапах.
              Гость исключение: ему всё ещё нужна регистрация до оплаты, поэтому у
              него остаётся одна кнопка, ведущая в регистрацию с намерением купить. */}
          {isDemo && token ? (
            <BuyMoneyPointsRow
              productType="GAME"
              gameId={game?.id}
              from={location.pathname}
              // после оплаты баллами перезагрузки нет — уводим в раздел анкеты,
              // иначе человек остаётся на продающей странице с теми же кнопками
              onPurchased={() => navigate(ROUTES.INSIGHT_QUESTIONNAIRE_PAGE)}
              className="insight-form-new-description-page__buy-row"
            />
          ) : (
            <div className="insight-form-new-description-page__buy-button">
              <BaseButton
                onClick={() => onClickBuy()}
                {...(hasOwnBlankForms ? { unfilledGradient: true } : {})}
              >
                {isDemo
                  ? t("endgame_page.buyGame", { price: getDomainPrice() })
                  : t("insight_form_instruction_page.start")}
              </BaseButton>
            </div>
          )}
          {isDemo ? (
            <div className="insight-form-new-description-page__to-use">
              {t("insight_form_description_page.toUse")}
            </div>
          ) : null}
        </WrapperPage>
      </div>
    </>
  );
});
